/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { bribeAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

interface SubmitBribeProps {
  account: Address
  chainId: number
  config: Config
  bribeAddress: Address
  tokenAddress: Address
  amount: bigint
  bribeType: "vote" | "lp"
}

export const submitBribe = async ({
  account,
  chainId,
  config,
  bribeAddress,
  tokenAddress,
  amount,
}: SubmitBribeProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: bribeAbi as Abi,
        account,
        address: bribeAddress,
        args: [tokenAddress, amount],
        chainId,
        functionName: "notifyRewardAmount",
      },
    })
    return result
  } catch (error: any) {
    console.error("submitBribe", error)
    return { success: false, error: error.message, code: error.code }
  }
}
